import React from "react";
import PoModificationCreation from "./poModificationCreation";

const initialColumns = [
    { id: "productNumber", label: "Material Number", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "productNumber", label: "Service Number", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "description", label: "Material Description", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "description", label: "Service Description", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    // { id: "unit", label: "Unit", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "hsnSacCode", label: "HSN Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "hsnSacCode", label: "SAC Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "totalQuantity", label: "Total Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "deliveredQty", label: "Recieved Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "pendingQty", label: "Pending Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    // { id: "plantName", label: "Plant Name", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "netPrice", label: "Unit Price", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "netPrice", label: "Net Price", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "newValue", label: "New Price", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "INPUT_TEXT" },
    // { id: "netValue", label: "Net Value", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    // { id: "netValue", label: "Net Order Value", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    // { id: "purchaseRequisition", label: "Purchase Requisition", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    // { id: "deliveryDate", label: "Delivery Date", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "DATE" }
  ];

function PoPriceModificationCreation() {
  
  return (
    <>
      <PoModificationCreation 
        initialColumns={initialColumns}
        componentName="PRICE_MODIFICATION"    
        lineItemName="products"      
      />
    </>
  )
}

export default PoPriceModificationCreation;